export default "__VITE_ASSET__BspOn2P2__"